import {useSelector} from "react-redux";
import {permissionsUserSelector} from "../features/Auth/authSlice";

function useCan(permission) {
	const permissions = useSelector(permissionsUserSelector);
	return typeof permissions !== 'undefined' && typeof permissions[permission] !== 'undefined' && permissions[permission] === true;
}

export default useCan;